/**
 * @generated SignedSource<<9ca25d4765999971699da63b52a551c6>>
 * @relayHash d9f37737c93233ee84c99222f9e3ac40
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d9f37737c93233ee84c99222f9e3ac40

import { ConcreteRequest } from 'relay-runtime';
export type chAuditQuery$variables = {
  fromDate?: any | null;
  patientId: string;
  toDate?: any | null;
};
export type chAuditQuery$data = {
  readonly auditEvents: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly action: string;
        readonly eventTime: string;
        readonly jsonPayload: string | null;
        readonly userName: string;
      };
    }> | null;
  } | null;
};
export type chAuditQuery = {
  response: chAuditQuery$data;
  variables: chAuditQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fromDate"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "patientId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "toDate"
},
v3 = [
  {
    "alias": "auditEvents",
    "args": [
      {
        "kind": "Literal",
        "name": "first",
        "value": 1000
      },
      {
        "kind": "Variable",
        "name": "fromDate",
        "variableName": "fromDate"
      },
      {
        "kind": "Variable",
        "name": "patientId",
        "variableName": "patientId"
      },
      {
        "kind": "Variable",
        "name": "toDate",
        "variableName": "toDate"
      }
    ],
    "concreteType": "AuditEventConnection",
    "kind": "LinkedField",
    "name": "ch_auditEvents",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AuditEventEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AuditEvent",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "action",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "eventTime",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "userName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "jsonPayload",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "chAuditQuery",
    "selections": (v3/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/),
      (v2/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "chAuditQuery",
    "selections": (v3/*:: as any*/)
  },
  "params": {
    "id": "d9f37737c93233ee84c99222f9e3ac40",
    "metadata": {},
    "name": "chAuditQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "ccd5b1ba14f8b8e010a016fe8d75649e";

export default node;
